import React from 'react';
import TextField from 'material-ui/TextField';

export default class Field extends React.Component {

  constructor(props) {
    super(props);
    var val = this.props.value ? this.props.value : "";
    this.state = {
      value: val,
    };
  }

  componentWillReceiveProps = (e) => {
    this.setState({
      value: e.value ?  e.value : "",
    });
  }
    
  handleChange = (event) => {
    
    this.setState({
      value: event.target.value,
    }, () => {

      if (this.props.handleChange)
      {
        this.props.handleChange(this);
      }
    });
    
  };
  
  render() {
    return (
      <TextField
          style={{width: "100%"}}
          value={this.state.value}
          type={this.props.type}
          onChange={this.handleChange.bind(this)}
          multiLine={this.props.multiLine}
          autoComplete={this.props.autoComplete}
          floatingLabelText={this.props.floatingLabelText}
        />

    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Form/Field.jsx